import clsx from "clsx";
import { graphql, Link } from "gatsby";
import { Button } from "gatsby-theme-material-ui";
import { TagMultiple as TagMultipleIcon } from "mdi-material-ui";
import PropTypes from "prop-types";
import React from "react";
import Helmet from "react-helmet";

import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Layout from "../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      gridArea: "content",
      marginBottom: theme.spacing(4),
      minHeight: 400,
      [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(8)
      }
    },
    heading: {
      paddingBottom: theme.spacing(4)
    }
  })
);

const TagRoute = ({ data, location, pageContext }): ReactElement => {
  const classes = useStyles();

  const posts = data.allMarkdownRemark.edges;
  const postLinks = posts.map(post => (
    <li key={post.node.fields.slug}>
      <Link to={post.node.fields.slug}>{post.node.frontmatter.title}</Link>
    </li>
  ));
  const tag = pageContext.tag;
  const title = data.site.siteMetadata.title;
  const totalCount = data.allMarkdownRemark.totalCount;
  const tagHeader = `${totalCount} post${
    totalCount === 1 ? "" : "s"
  } tagged with “${tag}”`;

  return (
    <Layout pathname={location.pathname}>
      <Container className={clsx(classes.root)}>
        <Helmet title={`${tag} | ${title}`} />
        <Typography
          component="h1"
          variant="h4"
          className={clsx(classes.heading)}
        >
          {tagHeader}
        </Typography>
        <ul className="taglist">{postLinks}</ul>
        <Button
          variant="contained"
          color="default"
          className={classes.button}
          startIcon={<TagMultipleIcon />}
          to="/tags/"
        >
          Browse all tags
        </Button>
      </Container>
    </Layout>
  );
};

TagRoute.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.arrayOf({
        node: PropTypes.shape({
          frontmatter: PropTypes.object
        })
      }),
      totalCount: PropTypes.number
    }),
    site: PropTypes.string
  }),
  location: PropTypes.object,
  pageContext: PropTypes.shape({
    tag: PropTypes.string
  })
};

export default TagRoute;

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`;
